<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-2">
      <v-toolbar color="blue-grey darken-2" dark dense>
        <v-icon left>history</v-icon>
        <v-toolbar-title>Mutabakat Geçmişi</v-toolbar-title>
        <v-spacer />
        <v-btn icon :loading="loading" @click="load">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-layout wrap align-center class="mb-3">
          <v-flex xs12 sm3 class="pr-2">
            <v-menu v-model="startMenu" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filters.startDate"
                  label="Başlangıç"
                  prepend-icon="event"
                  readonly
                  clearable
                  hide-details
                  v-on="on"
                  @click:clear="filters.startDate = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filters.startDate" locale="tr-TR" @input="startMenu = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 class="pr-2">
            <v-menu v-model="endMenu" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filters.endDate"
                  label="Bitiş"
                  prepend-icon="event"
                  readonly
                  clearable
                  hide-details
                  v-on="on"
                  @click:clear="filters.endDate = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filters.endDate" locale="tr-TR" @input="endMenu = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 class="pr-2">
            <v-select
              v-model="filters.subType"
              :items="typeItems"
              item-text="label"
              item-value="value"
              label="İşlem tipi (tümü)"
              prepend-icon="tune"
              clearable
              hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="pl-2">
            <v-btn color="blue-grey darken-2" dark block class="rh-btn ma-0" :loading="loading" @click="load">
              <v-icon left small>filter_list</v-icon>
              Filtrele
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout wrap class="rh-stats mb-3">
          <v-flex xs6 sm3 class="pr-2">
            <div class="rh-stat">
              <div class="rh-stat-label">Kayıt</div>
              <div class="rh-stat-value">{{ filteredItems.length }}</div>
            </div>
          </v-flex>
          <v-flex xs6 sm3 class="pr-2">
            <div class="rh-stat rh-stat--purple">
              <div class="rh-stat-label">Girdiden Alım</div>
              <div class="rh-stat-value">{{ receiveCount }}</div>
            </div>
          </v-flex>
          <v-flex xs6 sm3 class="pr-2">
            <div class="rh-stat rh-stat--green">
              <div class="rh-stat-label">Alınan Toplam Has</div>
              <div class="rh-stat-value">{{ receivedHas.toFixed(4) }} <span class="rh-stat-unit">gr</span></div>
            </div>
          </v-flex>
          <v-flex xs6 sm3>
            <div class="rh-stat rh-stat--grey">
              <div class="rh-stat-label">Kapatma / Geri Alma</div>
              <div class="rh-stat-value">{{ closeUndoCount }}</div>
            </div>
          </v-flex>
        </v-layout>

        <div v-if="!filteredItems.length && !loading" class="rh-empty">
          <v-icon large color="grey lighten-1">history</v-icon>
          <div>Kayıt yok.</div>
        </div>
        <div v-else>
          <div class="rh-card" :class="cardClass(item.subType)" v-for="item in displayItems" :key="item.id">
            <div class="rh-icon" :class="iconClass(item.subType)">
              <v-icon color="white" small>{{ typeIcon(item.subType) }}</v-icon>
            </div>

            <div class="rh-card-l">
              <div class="rh-head">
                <span class="rh-title">{{ item.title || item.subTypeName }}</span>
                <span class="rh-chip" :class="chipClass(item.subType)">{{ item.subTypeName }}</span>
                <span v-if="item.intakeDate" class="rh-sub">{{ formatDate(item.intakeDate) }} tarihli girdi</span>
                <span v-if="item.supplierTypeName" class="rh-chip" :class="item.supplierTypeName === 'Atölye' ? 'rh-chip--ato' : 'rh-chip--raf'">{{ item.supplierTypeName }}</span>
                <span v-if="item.isGroup" class="rh-chip rh-chip--linked">
                  {{ item.children.length }} alım birleştirildi<template v-if="item.undoneCount"> · {{ item.undoneCount }} geri alındı</template>
                </span>
                <span v-else-if="item.linkedIntakeId" class="rh-chip rh-chip--linked">Girdiden</span>
                <span v-if="item.supplierName && item.supplierName !== item.title" class="rh-sub">{{ item.supplierName }}</span>
              </div>

              <div v-if="item.items && item.items.length" class="rh-items">
                <span class="rh-item" v-for="(it, idx) in item.items" :key="idx">{{ it }}</span>
              </div>

              <div v-if="item.note" class="rh-note">“{{ item.note }}”</div>

              <div v-if="item.isGroup" class="rh-sublist">
                <button
                  type="button"
                  class="rh-toggle"
                  :class="{ 'rh-toggle--open': expandedGroups[item.id] }"
                  :title="expandedGroups[item.id] ? 'Kapat' : 'Alımları tek tek göster'"
                  @click="toggleGroup(item.id)"
                >
                  <v-icon small>expand_more</v-icon>
                </button>
                <div v-if="expandedGroups[item.id]" class="rh-children">
                  <div class="rh-child" :class="{ 'rh-child--undone': c.isUndone }" v-for="c in item.children" :key="c.id">
                    <span class="rh-child-time">{{ formatDateTime(c.date) }}</span>
                    <span class="rh-child-items">
                      <span class="rh-item" v-for="(ci, cix) in c.items" :key="cix">{{ ci }}</span>
                    </span>
                    <span class="rh-child-has">{{ Number(c.totalHas || 0).toFixed(4) }} gr</span>
                    <v-btn v-if="c.canUndo" small flat color="red darken-1" class="ma-0" @click="openActionDialog(c, 'undo')">Geri Al</v-btn>
                    <span v-else-if="c.isUndone" class="inv-chip inv-chip--grey">Geri alınmış</span>
                  </div>
                </div>
              </div>

              <div class="rh-meta">
                <v-icon x-small color="blue-grey lighten-2">schedule</v-icon>
                <template v-if="item.isGroup && item.lastDate !== item.date">
                  {{ formatDateTime(item.lastDate) }} — {{ formatDateTime(item.date) }}
                </template>
                <template v-else>{{ formatDateTime(item.date) }}</template>
                <span class="rh-dot">·</span>
                <v-icon x-small color="blue-grey lighten-2">person</v-icon>
                {{ item.userName }}
              </div>
            </div>

            <div class="rh-card-r">
              <div v-if="item.totalHas != null" class="rh-has">
                <div class="rh-has-value">{{ Number(item.totalHas).toFixed(4) }}</div>
                <div class="rh-has-label">gr has</div>
              </div>
              <v-btn v-if="item.isGroup && item.undoableCount > 0" color="red darken-1" dark class="rh-btn ma-0 ml-3" @click="openActionDialog(item, 'undo')">
                <v-icon small left>undo</v-icon>
                Tümünü Geri Al ({{ item.undoableCount }})
              </v-btn>
              <span v-else-if="item.isGroup" class="inv-chip inv-chip--grey ml-3">
                <v-icon small>undo</v-icon>
                Tümü geri alınmış
              </span>
              <v-btn v-else-if="item.canUndo" color="red darken-1" dark class="rh-btn ma-0 ml-3" @click="openActionDialog(item, 'undo')">
                <v-icon small left>undo</v-icon>
                Geri Al
              </v-btn>
              <span v-else-if="item.isUndone" class="inv-chip inv-chip--grey ml-3">
                <v-icon small>undo</v-icon>
                Geri alınmış
              </span>
              <v-btn v-if="item.canReopen" color="teal darken-1" dark class="rh-btn ma-0 ml-3" @click="openActionDialog(item, 'reopen')">
                <v-icon small left>lock_open</v-icon>
                Geri Aç
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="actionDialog" persistent max-width="520">
      <v-card v-if="actionTarget">
        <v-card-title class="white--text" :class="actionMode === 'undo' ? 'red darken-1' : 'teal darken-1'">
          <v-icon left color="white">{{ actionMode === 'undo' ? 'undo' : 'lock_open' }}</v-icon>
          {{ actionMode === 'undo' ? 'Kabulü Geri Al' : 'Girdiyi Geri Aç' }}
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="body-2 mb-2">{{ actionTarget.summary }}</div>
          <v-alert v-if="actionMode === 'undo'" :value="true" type="warning" outline class="mb-3">
            DİKKAT: Bu kabul geri alınırsa alınan adetler envanterden düşülür ve girdinin kalanı yeniden açılır.
            Ürünler bu arada satılmış/zimmetlenmişse işlem engellenir.
          </v-alert>
          <v-alert v-else :value="true" type="info" outline class="mb-3">
            Girdi yeniden mutabakat takibine alınacak; kalan bakiyesi bekleyen listelerine ve toplamlara geri döner.
          </v-alert>
          <v-textarea
            v-model="actionNote"
            :label="actionMode === 'undo' ? 'Geri alma sebebi' : 'Not (opsiyonel)'"
            rows="2"
            counter="500"
            maxlength="500"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer />
          <v-btn flat color="grey" @click="actionDialog = false" :disabled="acting">Vazgeç</v-btn>
          <v-btn
            :color="actionMode === 'undo' ? 'red darken-1' : 'teal darken-1'"
            dark
            class="rh-btn"
            :loading="acting"
            :disabled="actionMode === 'undo' && !actionNote.trim()"
            @click="confirmAction"
          >
            {{ actionMode === 'undo' ? 'Evet, Geri Al' : 'Geri Aç' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000" top>
      {{ snackbarMessage }}
      <v-btn flat @click="snackbar = false">Kapat</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'AdminReconciliationHistory',
  data() {
    return {
      loading: false,
      items: [],
      filters: { startDate: null, endDate: null, subType: null },
      startMenu: false,
      endMenu: false,
      typeItems: [
        { label: 'Girdiden Alım', value: 721 },
        { label: 'Alım Geri Alma', value: 722 },
        { label: 'Mutabakat Kapatma', value: 720 },
        { label: 'Rafineri Girdisi', value: 714 },
        { label: 'Külçe Girişi', value: 700 },
        { label: 'Ziynet Girişi', value: 701 },
        { label: 'Diğer Girişi', value: 702 },
        { label: 'Takı Girişi', value: 703 },
      ],
      actionDialog: false,
      actionTarget: null,
      actionMode: 'undo',
      actionNote: '',
      acting: false,
      expandedGroups: {},
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
    };
  },
  computed: {
    filteredItems() {
      if (!this.filters.subType) return this.items;
      return this.items.filter((i) => i.subType === this.filters.subType);
    },
    displayItems() {
      const out = [];
      const groups = new Map();
      for (const it of this.filteredItems) {
        if (it.subType === 703 && it.linkedIntakeId && !this.filters.subType) continue;
        if (it.subType !== 721 || !it.linkedIntakeId) {
          out.push(it);
          continue;
        }
        const key = 'grp-' + it.linkedIntakeId;
        let g = groups.get(key);
        if (!g) {
          g = {
            id: key,
            isGroup: true,
            subType: 721,
            subTypeName: it.subTypeName,
            title: it.title,
            userName: it.userName,
            supplierName: it.supplierName,
            intakeDate: it.intakeDate,
            date: it.date,
            lastDate: it.date,
            totalHas: 0,
            undoneHas: 0,
            children: [],
          };
          groups.set(key, g);
          out.push(g);
        }
        g.children.push(it);
        if (it.userName && g.userName && it.userName !== g.userName) g.userName = 'birden fazla kullanıcı';
        if (!it.isUndone) g.totalHas += Number(it.totalHas) || 0;
        g.undoneHas += it.isUndone ? Number(it.totalHas) || 0 : 0;
        if (it.date < g.lastDate) g.lastDate = it.date;
      }
      return out.map((g) => {
        if (!g.isGroup) return g;
        if (g.children.length === 1) return g.children[0];
        g.items = this.mergeGroupItems(g.children.filter((c) => !c.isUndone));
        g.undoableCount = g.children.filter((c) => c.canUndo).length;
        g.undoneCount = g.children.filter((c) => c.isUndone).length;
        return g;
      });
    },
    receiveCount() {
      return this.filteredItems.filter((i) => i.subType === 721).length;
    },
    groupUndoTarget() {
      const t = this.actionTarget;
      if (!t || !t.isGroup) return null;
      return (t.children || []).filter((c) => c.canUndo);
    },
    receivedHas() {
      return this.filteredItems
        .filter((i) => i.subType === 721 && !i.isUndone)
        .reduce((sum, i) => sum + (Number(i.totalHas) || 0), 0);
    },
    closeUndoCount() {
      return this.filteredItems.filter((i) => i.subType === 720 || i.subType === 722).length;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    formatDateTime(d) {
      if (!d) return '-';
      return new Date(d).toLocaleString('tr-TR');
    },
    formatDate(d) {
      if (!d) return '-';
      return new Date(d).toLocaleDateString('tr-TR');
    },
    typeIcon(subType) {
      if (subType === 721) return 'move_to_inbox';
      if (subType === 722) return 'undo';
      if (subType === 720) return 'lock';
      if (subType === 714) return 'factory';
      if (subType === 703) return 'diamond';
      if (subType === 700) return 'view_in_ar';
      if (subType === 701) return 'monetization_on';
      return 'category';
    },
    iconClass(subType) {
      if (subType === 721) return 'rh-icon--purple';
      if (subType === 722) return 'rh-icon--red';
      if (subType === 720) return 'rh-icon--grey';
      if (subType === 714) return 'rh-icon--brown';
      return 'rh-icon--teal';
    },
    chipClass(subType) {
      if (subType === 721) return 'rh-chip--purple';
      if (subType === 722) return 'rh-chip--red';
      if (subType === 720) return 'rh-chip--grey';
      if (subType === 714) return 'rh-chip--brown';
      return 'rh-chip--teal';
    },
    cardClass(subType) {
      if (subType === 722) return 'rh-card--red';
      if (subType === 720) return 'rh-card--grey';
      return '';
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.filters.startDate) params.startDate = this.filters.startDate;
        if (this.filters.endDate) params.endDate = this.filters.endDate;
        this.items = (await this.$store.dispatch('inventory/getReconciliationHistory', params)) || [];
      } catch (e) {
        this.showError(e);
      } finally {
        this.loading = false;
      }
    },
    toggleGroup(key) {
      this.$set(this.expandedGroups, key, !this.expandedGroups[key]);
    },
    mergeGroupItems(children) {
      const counts = new Map();
      for (const c of children)
        for (const raw of c.items || []) {
          const m = /^(.*) ×(\d+)$/.exec(raw);
          const name = m ? m[1] : raw;
          const qty = m ? Number(m[2]) : 1;
          counts.set(name, (counts.get(name) || 0) + qty);
        }
      return Array.from(counts.entries()).map(([n, q]) => `${n} ×${q}`);
    },
    openActionDialog(item, mode) {
      this.actionTarget = item;
      this.actionMode = mode;
      this.actionNote = '';
      this.actionDialog = true;
    },
    async confirmAction() {
      if (!this.actionTarget) return;
      if (this.actionMode === 'undo' && !this.actionNote.trim()) return;
      this.acting = true;
      try {
        let res;
        if (this.actionMode === 'undo' && this.actionTarget.isGroup) {
          const targets = this.groupUndoTarget || [];
          let done = 0;
          for (const c of targets) {
            await this.$store.dispatch('inventory/undoReceiveIntake', { batchId: c.batchId, note: this.actionNote });
            done += 1;
          }
          res = { message: `${done} alım geri alındı` };
        } else if (this.actionMode === 'undo') {
          res = await this.$store.dispatch('inventory/undoReceiveIntake', {
            batchId: this.actionTarget.batchId,
            note: this.actionNote,
          });
        } else {
          res = await this.$store.dispatch('inventory/reopenSupplierIntake', {
            supplierType: this.actionTarget.reopenSupplierType,
            id: this.actionTarget.reopenIntakeId,
            note: this.actionNote,
          });
        }
        this.actionDialog = false;
        this.snackbarMessage = (res && res.message) || (this.actionMode === 'undo' ? 'Kabul geri alındı' : 'Girdi geri açıldı');
        this.snackbarColor = 'success';
        this.snackbar = true;
        await this.load();
      } catch (e) {
        this.showError(e);
      } finally {
        this.acting = false;
      }
    },
    showError(e) {
      this.snackbarMessage = (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || 'Bir hata oluştu';
      this.snackbarColor = 'error';
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.rh-stat {
  border: 1px solid #e5e9f0;
  border-left: 4px solid #b0bec5;
  border-radius: 8px;
  padding: 10px 14px;
  background: #fff;
}
.rh-stat--purple { border-left-color: #5e35b1; }
.rh-stat--green { border-left-color: #2e7d32; }
.rh-stat--grey { border-left-color: #78909c; }
.rh-stat-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #90a4ae;
  font-weight: 600;
}
.rh-stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #263238;
  font-family: Menlo, Consolas, monospace;
  line-height: 1.3;
}
.rh-stat-unit {
  font-size: 12px;
  color: #90a4ae;
  font-weight: 600;
}
.rh-card {
  border: 1px solid #e5e9f0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  background: #fff;
  display: flex;
  align-items: center;
}
.rh-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 14px;
  background: #90a4ae;
}
.rh-icon--purple { background: #5e35b1; }
.rh-icon--red { background: #c62828; }
.rh-icon--grey { background: #78909c; }
.rh-icon--brown { background: #6d4c41; }
.rh-icon--teal { background: #00897b; }
.rh-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.rh-title {
  font-size: 16px;
  font-weight: 700;
  color: #263238;
  margin-right: 8px;
}
.rh-sublist {
  margin-top: 8px;
}
.rh-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #d1c4e9;
  border-radius: 6px;
  background: #ede7f6;
  color: #5e35b1;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.rh-toggle:hover {
  background: #d1c4e9;
  border-color: #b39ddb;
}
.rh-toggle .v-icon {
  color: #5e35b1;
  transition: transform 0.2s;
}
.rh-toggle--open .v-icon {
  transform: rotate(180deg);
}
.rh-children {
  margin-top: 6px;
  border-left: 2px solid #d1c4e9;
  padding-left: 10px;
}
.rh-child {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
  font-size: 12.5px;
  color: #546e7a;
  flex-wrap: wrap;
}
.rh-child-time {
  min-width: 132px;
  color: #90a4ae;
}
.rh-child-items {
  flex: 1;
  min-width: 140px;
}
.rh-child-has {
  font-family: Menlo, Consolas, monospace;
  font-weight: 600;
  color: #37474f;
}
.rh-child--undone {
  opacity: 0.6;
}
.rh-child--undone .rh-child-has,
.rh-child--undone .rh-item {
  text-decoration: line-through;
}
.rh-chip--raf { background: #ede7f6; color: #5e35b1; border: 1px solid #d1c4e9; }
.rh-chip--ato { background: #efebe9; color: #6d4c41; border: 1px solid #d7ccc8; }
.rh-chip--linked {
  background: #ede7f6;
  color: #5e35b1;
  border: 1px solid #d1c4e9;
}
.rh-sub {
  font-size: 12px;
  color: #90a4ae;
  margin-left: 8px;
}
.rh-items {
  margin-top: 6px;
}
.rh-item {
  display: inline-block;
  background: #eceff1;
  border: 1px solid #dfe6e9;
  border-radius: 4px;
  padding: 1px 8px;
  margin: 2px 6px 2px 0;
  font-size: 12px;
  color: #37474f;
  font-family: Menlo, Consolas, monospace;
}
.rh-note {
  font-size: 12.5px;
  color: #546e7a;
  font-style: italic;
  margin-top: 5px;
}
.rh-dot {
  margin: 0 6px;
  color: #cfd8dc;
}
.rh-has {
  text-align: right;
  padding-right: 4px;
}
.rh-has-value {
  font-family: Menlo, Consolas, monospace;
  font-size: 17px;
  font-weight: 700;
  color: #37474f;
  line-height: 1.1;
}
.rh-has-label {
  font-size: 10.5px;
  color: #90a4ae;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.rh-card--red {
  background: #ffebee;
  border-color: #ffcdd2;
}
.rh-card--grey {
  background: #f6f8f9;
  border-color: #cfd8dc;
}
.rh-card-l {
  min-width: 0;
  padding-right: 12px;
  flex: 1;
}
.rh-card-r {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.rh-meta {
  font-size: 11.5px;
  color: #90a4ae;
  margin-top: 6px;
}
.rh-meta .v-icon {
  vertical-align: middle;
  margin-right: 2px;
}
.rh-chip {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-family: Menlo, Consolas, monospace;
  font-size: 11px;
  font-weight: 600;
  vertical-align: middle;
}
.rh-chip--purple {
  background: #ede7f6;
  color: #5e35b1;
  border: 1px solid #d1c4e9;
}
.rh-chip--red {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}
.rh-chip--grey {
  background: #eceff1;
  color: #546e7a;
  border: 1px solid #cfd8dc;
}
.rh-chip--brown {
  background: #efebe9;
  color: #6d4c41;
  border: 1px solid #d7ccc8;
}
.rh-chip--teal {
  background: #e0f2f1;
  color: #00695c;
  border: 1px solid #b2dfdb;
}
.rh-btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.4px;
  box-shadow: none;
}
.rh-empty {
  text-align: center;
  padding: 40px 0;
  color: #90a4ae;
  font-size: 14px;
}
.rh-empty .v-icon {
  margin-bottom: 8px;
}
@media (max-width: 700px) {
  .rh-card {
    flex-wrap: wrap;
  }
  .rh-card-r {
    margin-top: 10px;
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
